import { parseTicker } from './parse';
import { resolvedGamePair } from './describeMarket';

// GameDetail (beta) link target derived from a per-row Kalshi ticker.
// Returns null when the ticker isn't a per-day game (playoff-series rows
// carry a sentinel '9999-' date that has no calendar meaning) so we
// silently skip linking on those rows.
//
// A CANDIDATE, not proof the page has a game (#1184): a retired ticker still
// parses to a URL Game Detail renders empty. Callers that open it from old
// account activity check it live first (`components/accountRecord/gameDestination`).
export function gameDetailHrefFromTicker(ticker: string): string | null {
  // Venue-agnostic parse so PM-* tickers resolve to the same {game, date}
  // shape and link out to the same /game/:date/:a/:b detail page.
  const parsed = parseTicker(ticker);
  // `resolvedGamePair`, not `parsed.game`: a soccer draw or BTTS leg refuses to
  // midpoint-guess its packed pair (#837), so the parser alone leaves those
  // rows permanently unlinked. The shared rule recovers the pair from the
  // producer's canonical away/home when hydra has stamped the fixture, or,
  // when no live row exists, from the pair kept for the account's own tickers
  // (#1134), or, for a CBB total, from its game's moneyline legs live in the
  // store (#1364). PositionTracker's `gameDetailHref` never reads the kept pair
  // or the legs (the live row, else the parser), so a retired CFB total and a
  // proven CBB total link here but not from their cards. Still null when
  // nothing proves the pair: an unproven pair never becomes a link.
  const pair = resolvedGamePair(ticker, parsed);
  if (!pair || !parsed.date) return null;
  if (parsed.date.startsWith('9999')) return null;
  // Game-day order, NOT alpha-sorted: the route renders away/home (see
  // gameDetailHref), the page header prints the same, and the tab title reads
  // it back. Sorting here used to hand a NYY-at-BOS row the URL /BOS/NYY,
  // which the detail page still matched (matching is order-independent) while
  // every reader of the URL saw the matchup backwards (#781).
  return `/game/${parsed.date}/${pair.awayCode}/${pair.homeCode}`;
}

